export default __webpack_public_path__ + "static/media/whatsa.f8e8fd65.svg";